// Ported from src/components/NodeStatus/NodeStatus.js on 2026-10-05.
import type { DeviceStatusDevice } from '../../types/deviceControl.types';
import LoadingDots from 'components/UI/LoadingDots';
import { useDeviceStatusLoading } from 'features/Integrations/hooks/useDeviceStatusLoading';
import React, { useEffect, useState } from 'react';
import { getDeviceStatusCode } from 'utils/devices/icon.utils';
import styles from './assets/NodeStatus.module.css';

// List of valid statuses and which device types can have them
const VALID_STATUSES = [
  'Online', // Flood, USGS, Buoy, Exacq Vision
  'Open', // Manual Road Closure, Technology Bridge_Flashing Lights
  'Idle', // Technology Bridge_Siren/Giant Voice
  'Slow', // Flood
  'Rising', // Flood
  'Dropping', // Flood
  'Alerting', // Technology Bridge_Siren/Giant Voice
  'Closed', // Manual Road Closure, Technology Bridge_Flashing Lights
  'Flooding', // Flood
  'Warning', // Flood, Technology Bridge_Flashing Lights
  'Maintenance', // Flood, Technology Bridge_Flashing Lights, Technology Bridge_Siren/Giant Voice
  'Offline', // All device types (fallback/default)
  'Major', // USGS Monitoring Station
  'Moderate', // USGS Monitoring Station
  'Minor', // USGS Monitoring Station
  'Action', // USGS Monitoring Station
  'Inactive', // Technology Bridge (fallback/generic)
  'Active', // Technology Bridge (fallback/generic)
  'API Error', // Technology Bridge (error state)
  'Loading',
];

export default function NodeStatus({ device }: { device: DeviceStatusDevice }) {
  const isLoading = useDeviceStatusLoading(device);
  const [status, setStatus] = useState(() => getDeviceStatusCode(device) || 'Offline');

  useEffect(() => setStatus(getDeviceStatusCode(device) || 'Offline'), [device]);

  const isValid = VALID_STATUSES.includes(status);
  if (!isValid) {
    console.error(`NodeStatus: Invalid status '${status}' for device`, device);
  }
  const displayStatus = isValid ? status : 'Offline';
  const resolvedStatus =
    device?.data || device?.device_type === 'Overwatch VMS' ? displayStatus : 'Offline';
  // No point yet and the covering fetch still in flight: not Offline, not known.
  const finalStatus = isLoading ? 'Loading' : resolvedStatus;

  return (
    <div className={styles.root} data-status={finalStatus}>
      {finalStatus === 'Loading' ? (
        <span className={styles.loadingContent}>
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
          <LoadingDots />
        </span>
      ) : (
        finalStatus
      )}
    </div>
  );
}
